import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { VriAPIResponse, VriAPIResult } from '../types';
import { Business } from '../types/business.type';
import { getErrorMessage } from '../customer-call-sdk/lib/API';

export interface GetSearchBusinessResult extends VriAPIResult {
    data?: {
        business?: Business[];
        totalElements: number;
    };
}

export interface GetSearchBusinessResponse extends VriAPIResponse {
    usersPage: {
        content: Business[];
        totalElements: number;
    };
}

export interface GetSearchBusinessPayload {
    searchData: string;
    limit: number;
    offset: number;
}

export const getSearchsBusiness = async (
    Paylod: GetSearchBusinessPayload,
): Promise<GetSearchBusinessResult> => {
    const result = {} as GetSearchBusinessResult;
    try {
        const { data: responseData } = await axios.post<GetSearchBusinessResponse>(
            END_POINT.SEARCH_BUSINESS,
            Paylod,
        );
        result.data = {
            business: responseData.usersPage.content,
            totalElements: responseData.usersPage.totalElements,
        };
    } catch (error) {
        result.error = error;
    }
    return result;
};

export interface GetAllBusinessRequestPayload {
    limit: number;
    offset: number;
}

export interface GetAllBusinessResult extends VriAPIResult {
    data?: {
        totalCount: number;
        businessList: Business[];
    };
}

export interface GetAllBusinessResponse extends VriAPIResponse {
    data: {
        totalCount: number;
        objects: Business[];
    };
}

export const getAllBusiness = async (
    payLoad: GetAllBusinessRequestPayload,
): Promise<GetAllBusinessResult> => {
    const result = {} as GetAllBusinessResult;
    try {
        const { data: responseData } = await axios.post<GetAllBusinessResponse>(
            END_POINT.GET_ALL_BUSINESS,
            payLoad,
        );
        result.data = {
            totalCount: responseData.data.totalCount,
            businessList: responseData.data.objects,
        };
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
};

export interface GetBusinessByIdResult extends VriAPIResult {
    data?: {
        businessList: Business[];
    };
}

export interface GetBusinessByIdResponse extends VriAPIResponse {
    data: {
        business: Business[];
    };
}
export const getBusinessListById = async (businessId: String): Promise<GetBusinessByIdResult> => {
    const result = {} as GetBusinessByIdResult;
    try {
        const { data: responseData } = await axios.post<GetBusinessByIdResponse>(
            END_POINT.GET_BUSINESS_BY_ID,
            {
                businessId,
            },
        );
        result.data = {
            businessList: responseData.data.business,
        };
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
};
